import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * cn() — merge Tailwind classes with conflict resolution.
 * Combines clsx (conditional classes) + tailwind-merge (dedup conflicts).
 *
 * @example
 * cn('px-2 py-1', isActive && 'bg-blue-500', 'px-4')  // → 'py-1 bg-blue-500 px-4'
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
